<template>
  <div class="col-12">
    <div class="row">
      <div class="col-md-3">
        <div
          class="nav flex-column nav-pills nav-perfil"
          id="pills-saude"
          role="tablist"
          aria-orientation="vertical"
        >
          <router-link class="nav-link"  v-if="this.exibeRelatorioPagAnual === false" :to="{ name: 'relatorioInformativoPagAtual' }">
            <span class="d-md-flex">Relatório Informativo Pagamento Anual</span>
            <i class="material-icons">bar_chart</i>
          </router-link>
          <router-link class="nav-link" :to="{ name: 'relatoriosaude' }">
            <span class="d-md-flex">Relatório de Coparticipação</span>
            <i class="material-icons">bar_chart</i>
          </router-link>
          <router-link
            class="nav-link"
            :to="{ name: 'relatorioutilizacaoxbeneficiario' }"
          >
            <span class="d-md-flex" style="text-align: left"
              >Relatório de Utilizações x Beneficiário</span
            >
            <i class="material-icons">bar_chart</i>
          </router-link>
          <router-link class="nav-link" v-if="this.usuarioLogado === '00123457'" role="tab" :to="{ name: 'listavidas' }">
            <span class="d-md-flex">Movimentação de Vidas</span>
            <i class="material-icons">work</i>
         </router-link> 

        </div>
      </div>
      <div class="col-md-9">
        <transition mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CdlSaude",
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
      ],
      codSocio: null,
      usuarioLogado: 0,
      exibeRelatorioPagAnual: false,
    };
  },
  methods: {},
  created() {
    this.usuarioLogado = this.$user.dadosCadastraisAssociado[0].codsociO_TEMP;
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    if (this.$route.path == "/produto/cdl-saude") {
      this.$router.push({ name: "2viacartao" });
    }
    this.codSocio = this.$user.dadosCadastraisAssociado[0].codsociO_TEMP;

    const dados = {
           CODSOCIO: `${this.$user.dadosCadastraisAssociado[0].codsociO_TEMP}`
        };
  this.$http
    .post("/api/CdlBh/RelInfoPagAnualExibicao", dados)
    .then((response) => {
      this.loading = false;
        console.log("Teste: " + response.data);
        if (response.data == true) {
          this.exibeRelatorioPagAnual = true;
        }       
    })
    .catch(() => {
      this.loading = false
      this.$toast.open({
        message: "Dados não encontrados!",
        type: "warning",
      });
    });
  }
  }


</script>

<style lang="scss" scoped>
@media screen and(max-width: 900px) {
  #pills-saude {
    display: flex;
    flex-direction: row !important;
    justify-content: space-between;
    margin-bottom: 1rem;
    a {
      width: 48%;
      text-align: center;
      justify-content: center;
      align-items: center;
      span {
        display: none;
      }
    }
  }
}
</style>
